import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/state/appState';
import { previousCreateJobStep } from '../../store/actions/createJobActions';
import { AppDispatch } from '../../store/actions/appDispatch';

export default function CreateJobPrevStep(props: Props) {
	const hasPrevSteps = useSelector<AppState, boolean>(s => {
		return (s.createJobsState.byEngagement.get(props.engagementId)?.prevSteps.length ?? 0) > 0;
	});
	const dispatch = useDispatch<AppDispatch>();
	
	return (
		<React.Fragment>
			<button className="btn btn_link" disabled={!hasPrevSteps} onClick={() => dispatch(previousCreateJobStep(props.engagementId))}>Back</button>
		</React.Fragment>
	);
}

interface Props {
    engagementId: number;
}
